export const merchantBusinessProfileMobileCardClass =
  'rounded-merchant-stat bg-merchant-surface p-4 shadow-merchant-stat'
